$(document).ready(function () {
  let visibleMetafields = new Set();

  function updateVisibleMetafieldsFromSelected() {
    visibleMetafields = new Set();

    $('.product-radio:checked').each(function () {
      const handle = $(this).val();
      const json = $(`#product-data-${handle} script`).html();
      if (!json) return;
      const data = JSON.parse(json);

      for (const key in data.metafields) {
        const value = data.metafields[key];
        if (value && typeof value === 'string' && value.trim() !== '') {
          visibleMetafields.add(key);
        }
      }
    });
  }

  function renderProductWithKeys(data, index, visibleKeys) {
  const truncate = (str, maxLength) => str.length > maxLength ? str.slice(0, maxLength) + "..." : str;

  let html = `
    <div class="sticky-components">
      <img class="featured-img" src="${data.featured_image}" alt="${data.title}">
    </div>
    <span class="caption-with-letter-spacing font-body-bold center series">${data.series}</span>
    <h3 class="product-title h4 center">${truncate(data.title, 80)}</h3>
    <span class="product-skus center">SKUs: ${data.skus}</span>
    <a class="button" target="_blank" href="${data.url}">Learn More</a>
    <ul class="features-list">
  `;

  for (const key of visibleKeys) {
    const rawValue = data.metafields[key];
    const value = rawValue && typeof rawValue === 'string' ? rawValue.trim() : '';

    if (value.match(/\.(png|jpg|jpeg|gif|webp)$/i)) {
      html += `<li><span class="caption-with-letter-spacing">${key}</span><img class="img-specs" src="${value}" alt="${key}"></li>`;
    } else if (value) {
      html += `<li><span class="caption-with-letter-spacing">${key}</span><span class="center">${value}</span></li>`;
    } else {
      html += `<li><span class="caption-with-letter-spacing">${key}</span><span class="center">N/A</span></li>`;
    }
  }

  html += '</ul>';

  const $column = $(`#product-${index}`);
  $column.stop(true, true).hide().html(html).fadeIn(600);
}


  function updateRadios() {
    const selectedHandles = new Set();
    $('.product-radio:checked').each(function () {
      selectedHandles.add($(this).val());
    });

    $('.product-radio').each(function () {
      const $radio = $(this);
      const handle = $radio.val();

      if (selectedHandles.has(handle)) {
        $radio.prop('disabled', true);
        $radio.closest('label').css('opacity', 0.3).addClass('disabled');
      } else {
        $radio.prop('disabled', false);
        $radio.closest('label').css('opacity', 1).removeClass('disabled');
      }
    });
  }

  $('.custom-select .selected-label').on('click', function (e) {
    e.stopPropagation();
    $('.custom-options').not($(this).next()).slideUp();
    $(this).next('.custom-options').slideToggle();
  });

  $(document).on('click', function () {
    $('.custom-options').slideUp();
  });

  function renderAllSelectedProducts() {
    const selectedProducts = [];
    const visibleKeys = new Set();

    // Step 1: Gather all selected product data
    $('.product-radio:checked').each(function () {
      const handle = $(this).val();
      const index = $(this).closest('.custom-select').data('index');
      const json = $(`#product-data-${handle} script`).html();
      if (!json) return;
      const data = JSON.parse(json);
      selectedProducts.push({ handle, index, data });

      // Step 2: Identify all visible keys (with at least one non-empty value)
      for (const key in data.metafields) {
        const value = data.metafields[key];
        if (value && typeof value === 'string' && value.trim() !== '') {
          visibleKeys.add(key);
        }
      }
    });

    // Step 3: Render each column using same key set
    for (const product of selectedProducts) {
      renderProductWithKeys(product.data, product.index, visibleKeys);
    }
  }



  $('.product-radio').on('change', function () {
    const handle = $(this).val();
    const index = $(this).closest('.custom-select').data('index');
    const title = $(this).closest('label').find('span').text();
    const img = $(this).closest('label').find('img').attr('src');

    $(this).closest('.custom-select').find('.selected-label').html(`<img class="small-hide" src="${img}"> ${title}`);
    $(this).closest('.custom-options').slideUp();

    updateRadios();

    // ✅ Delay to ensure browser registers new selection
    setTimeout(function () {
      updateVisibleMetafieldsFromSelected();
      renderAllSelectedProducts();
    }, 0);
  });


  
  function clearThirdColumnOnMobile() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      const $thirdColumn = $('#product-3');
      const $thirdSelect = $('.custom-select[data-index="3"]');

      $thirdColumn.empty();
      $thirdSelect.find('.product-radio:checked').prop('checked', false);
      $thirdSelect.find('.selected-label').text('Select Product 3');

      updateRadios();
    }
  }

  setTimeout(function () {
    const usedHandles = new Set();
    $('.custom-select').each(function () {
      const index = parseInt($(this).data('index'), 10);

      if (index === 3 && window.matchMedia('(max-width: 767px)').matches) return;

      const $radios = $(this).find('.product-radio');
      for (let i = 0; i < $radios.length; i++) {
        const $radio = $($radios[i]);
        const handle = $radio.val();
        if (!usedHandles.has(handle)) {
          $radio.prop('checked', true).trigger('change');
          usedHandles.add(handle);
          break;
        }
      }
    });

    clearThirdColumnOnMobile();
  }, 0);

  $(window).on('resize', clearThirdColumnOnMobile);

  window.addEventListener('scroll', function () {
    document.body.classList.toggle('scrolled', window.scrollY > 150);
  });
});
